/*!

=========================================================
* Light Bootstrap Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import { Grid, Row, Col, Table ,Panel ,Image} from "react-bootstrap";

import Card from "components/Card/Card.jsx";
import { thArray, tdArray } from "variables/Variables.jsx";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";

class Profissionais extends Component {
  constructor(props){
      super(props)
      this.handleChange = this.handleChange.bind(this)
      this.componentWillReceiveProps.bind(this)

      this.state={
          pesquisar:'',
         
          thArray:["ID", "Celular", "Cidade da Empresa","CNPJ/CPF",'Email Particular','Endereco','Horario Atendimento','Inscrição Estadual','Inscrição Municipal','Nome Fantasia','Possui Funcionarios','Razao Social','Referencia de Clientes','Telefone Fixo','Tipos de Serviço que Executa' ],
          
          tdArrayOriginal:[
           ...props.profissionais
            ],
          tdArray:[
          ...props.profissionais
            ],
            fotos:[],
            fotosrgecpf:[]
      }

  }
  componentWillReceiveProps(nxtprops){
      console.log('NOVAS PROPS',nxtprops)
  
      this.setState({
          tdArray:nxtprops.profissionais,
          tdArrayOriginal:nxtprops.profissionais,

      })
      if(nxtprops.profissionais && nxtprops.profissionais.length > 0){
        this.setState({
          fotos:nxtprops.profissionais[0][15],
          fotosrgecpf:nxtprops.profissionais[0][16]

        })
      }
  }
  handleChange(event) {
    try{
      event.preventDefault();  
      let pesquisar = event.target.value
      let arrayResultados = []

      console.log('Termo para pesquisar',pesquisar)
  
     if(!pesquisar || (pesquisar.length === 0)) {
         arrayResultados = this.state.tdArrayOriginal
        }else{
            this.state.tdArray.forEach((mensagem)=>{
                if(mensagem[1].toLowerCase().includes(pesquisar.toLowerCase()) || mensagem[2].toLowerCase().includes(pesquisar.toLowerCase())){
                    arrayResultados.push(mensagem)
                }
            })
        }
     
     this.setState({tdArray:arrayResultados,pesquisar})
    
    }catch(e){
      console.log('HOUVE UM ERRO NO SUBMIT',e);
    }
  }
  render() {
    
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Mensagens"
                category="Mensagens dos Clientes"
                ctTableFullWidth
                ctTableResponsive
                content={
                <Grid fluid style={{marginRight:14,marginLeft:14}}>

                  <Row>
                      <Col>
                      <form onSubmit={this.handleSubmit}>
                    
                    
                    <FormInputs
                      ncols={["col-md-10"]}
                      onChange={this.handleChange}
                      properties={[
                        {
                          label: "Pesquisar:",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "Pesquisar",
                          value:`${this.state.pesquisar}`,
                          onChange:this.handleChange
                          
                        }
                      ]}
                    />
                    </form>
                      </Col>
                  </Row>
                  <Row>
                      
                      <Col md={12} >
                      <Table striped hover>
                    <thead>
                      <tr>
                        {this.state.thArray.map((prop, key) => {
                          return <th key={key}>{prop}</th>;
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {(this.state.tdArray) && this.state.tdArray.map((prop, key) => {
                        console.log('KEY',key,'prop',prop)
                      
                        return (
                          <tr onClick={()=>{
                                  console.log('CLICOU NA LINHA',prop)
                                  this.setState({nome:prop[1],mensagem:prop[2],fotos:prop[15],fotosrgecpf:prop[16]})
                              }} key={key}>
                            {prop.map((prop, key) => {
                              if((key === 15 )|| (key === 16)) return
                              return <td  key={key}>{prop}</td>;
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                    </Table>
                      </Col>
                      <Col md={12}>
                      <Panel>
                            <Panel.Heading>Fotos:</Panel.Heading>
                            <Panel.Body>
                            <Grid style={{margin:0}}>
                              <Row>
                                <Col>Fotos do Rg E Cpf</Col>
                              </Row>
                              <Row>
                                {
                                 (this.state.fotos.length > 0) && this.state.fotos.map((foto)=>{
                                    return(
                                      <Image src={foto} thumbnail />
                                    )
                                  })
                                }
                              </Row>
                              <Row>
                                <Col>Fotos de Serviços Feitos:</Col>
                              </Row>
                              <Row>
                                {
                                 (this.state.fotosrgecpf.length > 0) && this.state.fotosrgecpf.map((foto)=>{
                                    return(
                                      <Image src={foto} thumbnail />
                                    )
                                  })
                                }
                              </Row>
                            </Grid>
                                      
                               </Panel.Body>
                        </Panel> 
                      </Col>
                  </Row>
                  
                </Grid>
                  
                 
                }
              />
            </Col>

           
          </Row>
        </Grid>
      </div>
    );
  }
}

export default Profissionais;
